import styled, { css } from 'styled-components';
import { Menu24 } from '@carbon/icons-react';
import { darken } from 'polished';
import { Link } from 'react-router-dom';
import { ChevronRight16, ChevronDown16 } from '@carbon/icons-react';

const Container = styled.div`
  background: ${({ theme }) => theme.colors.lightGrey};
  padding: 0.5rem;
  width: ${({ isOpen }) => (isOpen ? '18rem' : '3rem')};
  transition: 100ms ease;
`;

const MenuIcon = styled(Menu24)`
  cursor: pointer;
`;

const MenuLink = styled(Link)`
  width: 100%;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.darkGrey};
  padding: ${({ level }) => `0.5rem 0.5rem 0.5rem ${level * 1 + 0.5}rem`};
  :hover {
    background: ${({ theme }) => darken(0.1, theme.colors.lightGrey)};
  }
  ${({ active, theme }) =>
    active &&
    css`
      border-left: 5px solid ${theme.colors.primary};
    `}
`;

const MenuTopStyle = styled.div`
  width: 100%;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.darkGrey};
  background: ${({ theme }) => darken(0.15, theme.colors.lightGrey)};
  padding: ${({ level }) => `0.5rem 0.5rem 0.5rem ${level * 1 + 0.5}rem`};
  :hover {
    background: ${({ theme }) => darken(0.1, theme.colors.lightGrey)};
  }
  cursor: pointer;
  ${({ active, theme }) =>
    active &&
    css`
      border-left: 5px solid ${theme.colors.primary};
    `}
`;

const MenuBlock = styled.div`
  ${({ level }) =>
    level === 0 &&
    css`
      margin-bottom: 0.2rem;
    `}
`;

const MenuTop = ({ children, onClick, isOpen, level, active = false }) => (
  <MenuTopStyle onClick={onClick} level={level} active={active}>
    {children}
    {isOpen ? <ChevronDown16 /> : <ChevronRight16 />}
  </MenuTopStyle>
);

export { Container, MenuIcon, MenuLink, MenuTop, MenuBlock };
